// extracted by mini-css-extract-plugin
export var callCard = "_ng-0";
export var callMessageButton = "_ng-1";
export var helpIcon = "_ng-3";
export var helpIconContainer = "_ng-4";
export var verticalDivider = "_ng-2";